import { render, staticRenderFns } from "./pointsmall.vue?vue&type=template&id=2cb30b91"
import script from "./pointsmall.vue?vue&type=script&lang=js"
export * from "./pointsmall.vue?vue&type=script&lang=js"
import style0 from "./pointsmall.vue?vue&type=style&index=0&id=2cb30b91&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-hmt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb30b91')) {
      api.createRecord('2cb30b91', component.options)
    } else {
      api.reload('2cb30b91', component.options)
    }
    module.hot.accept("./pointsmall.vue?vue&type=template&id=2cb30b91", function () {
      api.rerender('2cb30b91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pointsmall.vue"
export default component.exports